// Slameros accessory: studded belt.
// Silhouette = horizontal belt + pyramid studs + buckle.
// Reads as pit-kid armor — the first thing that hits when you elbow into the crowd.

interface StuddedBeltProps {
  /** Primary fill (belt strap). Defaults to sharpie black. */
  bodyColor?: string;
  /** Accent fill (studs + buckle). Defaults to chrome silver. */
  accentColor?: string;
  /** Rendered size in px (square bounding box). */
  size?: number;
  /** Optional className for positioning. */
  className?: string;
}

export function StuddedBelt({
  bodyColor = '#141008',
  accentColor = '#c0c4ca',
  size = 48,
  className,
}: StuddedBeltProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      {/* Belt strap — horizontal black band */}
      <rect x="2" y="20" width="44" height="10" fill={bodyColor} />
      {/* Top edge highlight */}
      <rect x="2" y="20" width="44" height="1" fill="rgba(255,255,255,0.15)" />
      {/* Bottom edge shadow */}
      <rect x="2" y="29" width="44" height="1" fill="rgba(0,0,0,0.4)" />
      {/* Studs — pyramid pattern, 7 across */}
      {[6, 12, 18, 24, 30, 36, 42].map((cx, i) => (
        <g key={i}>
          {/* Stud base shadow */}
          <rect x={cx - 2.5} y="22" width="5" height="6" fill={accentColor} />
          {/* Stud highlight */}
          <polygon
            points={`${cx - 2.5},22 ${cx},20 ${cx + 2.5},22 ${cx},24`}
            fill={accentColor}
          />
          <polygon
            points={`${cx - 2.5},22 ${cx},20 ${cx + 2.5},22`}
            fill="rgba(255,255,255,0.4)"
          />
        </g>
      ))}
      {/* Buckle — left side, oversized */}
      <rect x="2" y="18" width="8" height="14" fill={accentColor} />
      <rect x="3" y="19" width="6" height="12" fill="none" stroke={bodyColor} strokeWidth="1" />
      {/* Buckle prong */}
      <rect x="5" y="22" width="2" height="6" fill={bodyColor} />
    </svg>
  );
}
